import { render, staticRenderFns } from "./TransactionMain.vue?vue&type=template&id=55cb5ba0&scoped=true&"
import script from "./TransactionMain.vue?vue&type=script&lang=js&"
export * from "./TransactionMain.vue?vue&type=script&lang=js&"
import style0 from "./TransactionMain.vue?vue&type=style&index=0&id=55cb5ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cb5ba0",
  null
  
)

export default component.exports